import React, { useState } from 'react'

export const BannerCookie = ({ btnBg = '#000000', btnText = '#ffffff' }) => {
    const lsLabel = 'clockwork-banner-cookie'

    const [isClicked, setClicked] = useState(!!localStorage.getItem(lsLabel))

    if (isClicked) return null
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999999,
                backgroundColor: 'white',
                padding: '1.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <div
                style={{
                    maxWidth: 1500,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '.5rem',
                    }}>
                    <h1
                        style={{
                            fontWeight: 500,
                            fontSize: '1.2rem',
                            marginBlock: 0,
                        }}>
                        Мы используем cookie
                    </h1>
                    <p
                        style={{
                            fontSize: '.85rem',
                        }}>
                        Продолжая использовать наш Сайт, Вы даете согласие на обработку (в т.ч. с
                        использованием метрической программы Яндекс.Метрика) файлов cookie, иных
                        пользовательских данных (сведения о Вашем ip-адресе, сведения о
                        местоположении, типе устройства, времени посещения страницы, сведения о
                        ресурсах сети Интернет, с которых были совершены переходы на наш сайт,
                        сведения о Ваших действиях на сайте), эта информация необходима для
                        функционирования сайта, проведения ретаргетинга и статистических
                        исследований и обзоров. Если Вы согласны, продолжайте пользоваться сайтом,
                        если Вы не хотите, чтобы Ваши данные обрабатывались необходимо установить
                        специальные настройки в браузере или покинуть сайт.
                    </p>
                </div>
                <button
                    onClick={() => {
                        localStorage.setItem('clockwork-banner-cookie', 'true')
                        setClicked(true)
                    }}
                    style={{
                        backgroundColor: btnBg,
                        color: btnText,
                        marginRight: 'auto',
                        padding: '.25rem 1rem',
                        cursor: 'pointer',
                        border: 0,
                        borderRadius: 5,
                    }}>
                    Хорошо
                </button>
            </div>
        </div>
    )
}
